import { computed, Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DebugLogger {
  private static readonly MAX_CHARS = 50_000;
  private readonly logs = signal<string[]>([]);

  readonly entries = this.logs.asReadonly();

  text = computed(() => {
    return this.logs().join('\n');
  });

  lastTimestamp = performance.now();

  log(message: string, data?: unknown) {
    const now = performance.now();
    const delta = now - this.lastTimestamp;

    this.lastTimestamp = now;

    const entry =
      `[${now.toFixed(1)} | +${delta.toFixed(1)}] ${message}` +
      (data ? ` ${JSON.stringify(data)}` : '');

    this.logs.update((logs) => {
      const next = [...logs, entry];

      const totalChars = next.reduce((sum, log) => sum + log.length, 0);

      return totalChars > DebugLogger.MAX_CHARS ? [entry] : next;
    });
  }

  clear() {
    this.logs.set([]);
  }
}
